<script>
  import { onMount } from "svelte";

  import { serverURL } from "./store";

  let token = "";
  let newPassword = "";
  let message = "";

  // When the page loads, it grabs the token from the URL
  onMount(() => {
    const hash = window.location.hash;

    // Remove the leading '#' and create a new URL object
    const url = new URL(hash.slice(1), window.location.origin);

    // Use URLSearchParams to get the query parameters
    const urlParams = new URLSearchParams(url.search);

    // Get the token from the URL parameters
    token = urlParams.get("token");
  });

  async function resetPassword() {
    if (window.location.hostname == "localhost") {
      $serverURL = "http://localhost:8080/";
    }
    try {
      const res = await fetch(`${$serverURL}api/users/new-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ resettoken: token, newPassword }),
      });

      const data = await res.json();
      message = data.message;

      if (res.status === 201) {
        setTimeout(() => {
          window.location.href = "/#/login";
        }, 1000);
      }
    } catch (err) {
      message = "Error resetting password.";
      console.error(err);
    }
  }
</script>

<img
  src="/img/Title.png"
  alt="title"
  style="position: absolute;
z-index: 100;
top: -190px;
left: -680px;
scale: 0.2;"
/>
<div style="background-color:#0c2d43">
  <div class="loginContainer">
    <div>
      <h2 style="color:white">Set a New Password</h2>
      <p
        style="
      position: absolute;
      top: 219px;
      color: #46bcbb;
      width: 400px;
  "
      >
        {message}
      </p>
      <input
        type="password"
        bind:value={newPassword}
        placeholder="New Password"
      />
      <button on:click={resetPassword}>Reset Password</button>
    </div>
  </div>
</div>

<style>
  .loginContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh; /* Full viewport height */
    margin: 0; /* Remove default margin */
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 10px; /* Space between form elements */
    max-width: 400px; /* Optional: Set a max width for the form */
    width: 100%;
    padding: 20px; /* Optional: Add some padding */
    background: #1a3a4f; /* Optional: Add a background color */
    border-radius: 8px; /* Optional: Round the corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add a shadow */
  }

  label {
    color: white;
    display: flex;
    flex-direction: column;
    background-color: #1a3a4f;
    text-align: left; /* Align text to the left */
    width: 100%; /* Ensure label takes full width */
  }

  input {
    width: 100%; /* Full width of the form */
    padding: 8px; /* Padding inside input fields */
    margin-top: 4px; /* Space between label and input */
    border: 1px solid #ccc; /* Border color */
    border-radius: 4px; /* Rounded corners */
  }

  button {
    align-self: center; /* Center the button horizontally */
    padding: 10px 20px; /* Padding inside the button */
    border: none; /* Remove default border */
    border-radius: 4px; /* Rounded corners */
    background-color: #46bcbb; /* Button background color */
    color: white; /* Button text color */
    cursor: pointer; /* Pointer cursor on hover */
    font-size: 16px; /* Font size for the button text */
  }

  button:hover {
    background-color: #0056b3; /* Darker background color on hover */
  }

  a {
    color: #46bcbb;
    position: relative;
    text-decoration: none;
    margin-top: 10px;
    top: -10px;
    right: -180px;
  }

  a:hover {
    text-decoration: underline; /* Underline link on hover */
  }
</style>
